import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {setStudents} from "../../../slice/groups/set-students/setStudentsSlice";

import {ApiStudentsResponse} from "../../../types/studentsSchema";
import {createRequestParams} from "../../../../../common/hook/create-request-params/createRequestParams";

interface FetchStudentsByGroupIdParams {
    groupId: string | undefined;
    from?: string;
    to?: string;
    page?: number;
}


export const fetchStudentsByGroupId = createAsyncThunk(
    "groups/fetchStudentsByGroupId",
    async ({groupId, from, to, page}: FetchStudentsByGroupIdParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<ApiStudentsResponse>(`/api/groups/${groupId}/students`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            });

            if (response.data && response.data.success) {

                thunkAPI.dispatch(setStudents(response.data.data));

            }

            // You can dispatch additional actions here if needed

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);